import React from 'react'
import { LearningItemAsPath } from '../../models/LearningItem'
import { useTranslation } from 'react-i18next'
import styles from '../CoursePage/CoursePage.module.scss'

export const CourseLearningPathQuickFacts = React.memo(function CourseLearningPathQuickFacts({
  learningItemAsPath,
}: {
  learningItemAsPath: LearningItemAsPath
}) {
  const { t } = useTranslation()

  return (
    <aside className={styles.CoursePageScheduledCourseQuickfacts}>
      <h2>{t('learning item.quickFacts')}</h2>

      <dl>
        {learningItemAsPath.categories.length > 0 && (
          <>
            <dt>{t('learning item.categories')}</dt>
            <dd>{learningItemAsPath.categories.map((category) => category.name).join(', ')}</dd>
          </>
        )}

        <dt>{t('learning item.price')}</dt>
        <dd>{t('learning item.included')}</dd>

        <dt>{t('learning item.certificate')}</dt>
        <dd>
          {!learningItemAsPath.createCertificate && <span>{t('generic cta.no')}</span>}
          {learningItemAsPath.createCertificate && !learningItemAsPath.certificateValidUntil && (
            <span>{t('learning item.certificate mode.unlimited')}</span>
          )}
          {learningItemAsPath.createCertificate && learningItemAsPath.certificateValidUntil && (
            <>
              <span>{t('learning item.certificate mode.limited')}, </span>
              <span>{t('format.DATE', { datetime: learningItemAsPath.certificateValidUntil })}</span>
            </>
          )}
        </dd>
      </dl>
    </aside>
  )
})
